module.exports = __webpack_public_path__ + "static/media/kabupaten.594c4b72.png";